import { useEffect, useState } from 'react';

export function useDashboardProfileForm(user) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');
  const [phone, setPhone] = useState('');

  const isGoogleUser = (user?.provider || 'local') === 'google';

  const formatBirthDate = (value) => {
    const s = String(value || '').trim();
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return `${m[3]}.${m[2]}.${m[1]}`;
    return s;
  };

  const normalizeRuPhoneDigits = (raw) => {
    let digits = String(raw || '').replace(/\D/g, '');
    const rawStr = String(raw || '').trim();

    if (rawStr.startsWith('+7') && digits[0] === '7') {
      digits = digits.slice(1);
    } else if (digits.length > 10 && (digits[0] === '7' || digits[0] === '8')) {
      digits = digits.slice(1);
    }

    return digits.slice(0, 10);
  };

  useEffect(() => {
    const fullName = String(user?.name || '').trim();
    const parts = fullName.split(' ').filter(Boolean);
    setFirstName(parts[0] || '');
    setLastName(parts.slice(1).join(' ') || '');
    setBirthDate(user?.birthDate || '');
    setCountry(user?.country || '');
    setCity(user?.city || '');
    setPhone(user?.phone || '');
  }, [user?.id]);

  return {
    isGoogleUser,
    firstName,
    lastName,
    birthDate,
    country,
    city,
    phone,
    setFirstName,
    setLastName,
    setBirthDate,
    setCountry,
    setCity,
    setPhone,
    formatBirthDate,
    normalizeRuPhoneDigits,
  };
}

